import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="conditional-required"
export default class extends Controller {
  static targets = ["statusSelect", "requiredField"]

  connect() {
    this.evaluate()

    this.observer = new MutationObserver(() => this.evaluate())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  evaluate() {
    const relaxed = this.statusSelectTargets.some((select) => {
      const option = select.options[select.selectedIndex]
      return option?.dataset.forActiveMembers === "false"
    })

    this.requiredFieldTargets.forEach((field) => {
      field.required = !relaxed
      if (!field.required) field.setCustomValidity("")
    })
  }
}